<script setup>
import { useI18n } from "vue-i18n";
import { setLocale } from "@/i18n";

const { locale } = useI18n();

function switchLocale(lang) {
  setLocale(lang);
}
</script>

<template>
  <div class="language-switcher" data-testid="language-switcher">
    <button
      :class="{ active: locale === 'en' }"
      @click="switchLocale('en')"
      aria-label="English"
    >
      EN
    </button>
    <span class="separator">|</span>
    <button
      :class="{ active: locale === 'pl' }"
      @click="switchLocale('pl')"
      aria-label="Polski"
    >
      PL
    </button>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;
@use "@/assets/scss/mixins" as *;

.language-switcher {
  display: flex;
  align-items: center;
  gap: 0.25rem;

  button {
    background: none;
    border: none;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    transition: color 0.2s;

    &:hover {
      color: var(--color-text);
    }

    &.active {
      color: var(--color-primary);
    }
  }
}

.separator {
  color: var(--color-text-muted);
  font-size: 0.75rem;
}

@include respond-to("md") {
  .language-switcher button {
    padding: 0.5rem 0.75rem;
    min-height: 44px;
    min-width: 44px;
  }
}
</style>
